






































import { Component, Vue } from "vue-property-decorator";
import PanelGroup from "@/components/PanelGroup.vue";
import WineryTable from "./components/WineryTable.vue";
import WineryEdit from "./components/WineryEdit.vue";
import { ITabModel, IPanelData } from "@/data/commonModel";
import { IWineryModel } from "./data/wineryModel";
import { WineryModule } from "@/store/modules/winery";

@Component({
  components: {
    PanelGroup,
    WineryTable,
    WineryEdit,
  },
})
export default class extends Vue {
  editDialogVisible: boolean = false;
  isOrdering: boolean = false; // 是否在排序中
  editType: string = "add";
  panelObj: IPanelData = { type: "all", searchText: "" ,show:true};
  wineryModel: IWineryModel | null = null;

  get tabs(): ITabModel[] {
    const arr = [
      {
        title: `全部(${WineryModule.WineryCountRes.allCount})`,
        key: "all",
      },
      {
        title: `已发布(${WineryModule.WineryCountRes.publishedCount})`,
        key: "published",
      },
      {
        title: `未发布(${WineryModule.WineryCountRes.unpublishedCount})`,
        key: "unpublished",
      },
    ];
    return arr;
  }
  mounted() {
    WineryModule.FetchWineryCountByStatus();
  }

  _handleSwitchTab(props: IPanelData) {
    this.panelObj = props;
    this.isOrdering = false;
  }

  _onClickAdd() {
    this.editType = "add";
    this.wineryModel = null;
    this.editDialogVisible = true;
  }

  // 开始/取消排序
  _onClickSort() {
    this.isOrdering = !this.isOrdering;
  }

  _handleEditWinerySuccess(type: string) {
    WineryModule.FetchWineryCountByStatus();
    const ref: WineryTable = this.$refs["winery-table"] as WineryTable;
    ref.refreshTable();
  }

  _handleEditWinery(value: IWineryModel) {
    this.editType = "edit";
    this.editDialogVisible = true;
    this.wineryModel = JSON.parse(JSON.stringify(value));
  }
}
